import { Directive, Input, Renderer2, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[mtMultiRouterLinkActive]',
  standalone: true
})
export class MultiRouterLinkActiveDirective implements OnInit, OnDestroy {
  readonly router = inject(Router);
  readonly el = inject(ElementRef);
  readonly renderer = inject(Renderer2);
  
  /**
   * Routes list to be active
   * @defaultValue []
   */
  @Input('multiRouterLinkActive') routes: string[] = [];

  /**
   * Active class name
   * @defaultValue 'active'
   */
  @Input() activeClass: string = 'active';

  /**
   * Observable subscription handler
   */
  private subscription!: Subscription;

  ngOnInit(): void {
    // Watch navigation changes
    this.subscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateActiveClass());

    this.updateActiveClass(); // Initial check
  }

  /**
   * Check the active route and add the active class to the element
   */
  private updateActiveClass(): void {
    const currentUrl = this.router.url;

    const isActive = this.routes.some(route =>
      currentUrl.startsWith(route) && !(currentUrl === '/dashboard/overview' && route === '/dashboard')
    );

    if (isActive) {
      this.renderer.addClass(this.el.nativeElement, this.activeClass);
    } else {
      this.renderer.removeClass(this.el.nativeElement, this.activeClass);
    }
  }

  /**
   * Unsubscribe the route change event
   */
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}